import React from 'react';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';

const TheirOwnWordsTextBlock = (): JSX.Element => (
  <HeadingAndSupportingText
    heading={{
      type: 'heading',
      size: 'lg',
      text: 'In their own words.',
      letterSpacing: -1,
    }}
    supportingText={{
      type: 'paragraph',
      size: 'lg',
      color: 'text-tertiary',
      text: "From first-time creators to the biggest names in personal development—here's what they're building on Mighty.",
    }}
    gap='spacing-2xl'
  />
);

export default TheirOwnWordsTextBlock;
